/* --- Le strict necessaire d'axios, sur `fetch` ----------------------------
   axios pesait 134 ko de source pour sept appels, dans deux ecrans, alors que
   tout le reste de l'application interroge deja l'API avec `fetch`.

   On en reprend exactement les trois comportements dont ces ecrans dependent,
   et rien de plus :

   - le corps est serialise en JSON et l'en-tete pose en consequence ;
   - un statut non-2xx LEVE. C'est le point qui compte : `fetch` resout
     tranquillement un 401, si bien qu'un `try/catch` ecrit pour axios
     laisserait passer un echec de connexion pour une reussite ;
   - l'erreur porte `e.response.data.detail`, la forme que les ecrans lisent
     deja pour afficher le message renvoye par l'API.

   La reponse garde la forme `{ data }` d'axios : les appelants n'ont pas a
   changer de vocabulaire. */

async function envoyer(methode, url, corps, options = {}) {
  const avecCorps = corps !== undefined;
  const reponse = await fetch(url, {
    method: methode,
    headers: {
      ...(avecCorps ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
    ...(avecCorps ? { body: JSON.stringify(corps) } : {}),
  });

  // Une reponse vide (204, ou une erreur renvoyee en texte) ne doit pas faire
  // echouer l'appel avant qu'on ait pu lire son statut.
  let data = null;
  try {
    data = await reponse.json();
  } catch (e) {
    data = null;
  }

  if (!reponse.ok) {
    const erreur = new Error(`HTTP ${reponse.status}`);
    erreur.response = { status: reponse.status, data };
    throw erreur;
  }
  return { data, status: reponse.status };
}

const api = {
  get: (url, options) => envoyer('GET', url, undefined, options),
  post: (url, corps, options) => envoyer('POST', url, corps, options),
  put: (url, corps, options) => envoyer('PUT', url, corps, options),
  delete: (url, options) => envoyer('DELETE', url, undefined, options),
};

export default api;
